import { Check, Info } from "lucide-react";
import { CtaButton } from "@/components/site/CtaButton";
import { Eyebrow } from "@/components/site/Sections";

const TIERS = [
  ["Draw & Paperwork Management", "$1,000–$1,500/mo per project", ["Lender draw packages prepared and submitted", "Invoice collection and organization", "Lien waiver tracking", "Budget vs. actual tracking"]],
  ["Full Rehab Management", "15–18% of rehab budget", ["Scope of work and contractor bidding", "Contractor coordination and scheduling", "Budget control and change-order review", "Draw management with your lender", "Weekly progress reports with photos"]],
  ["Rehab Audit", "$500–$1,500 flat per project", ["Pre-purchase scope-of-work review", "Rehab budget validation before you close", "Risk flags and timeline estimate"]],
];

export default function RehabManagement() {
  return (
    <section className="bg-[#F5F3EC] py-16 lg:py-24" data-testid="rehab-page">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <Eyebrow>Rehab Project Management</Eyebrow>
        <h1 className="mt-3 font-display text-4xl font-extrabold text-[#0B132B] sm:text-5xl">You Found the Deal. We Run the Rehab.</h1>
        <p className="mt-4 max-w-3xl text-slate-600">Renovation management for busy and out-of-area Pennsylvania investors: scope, contractors, schedule, budget and lender draws, with weekly photo updates.</p>
        <div className="mt-6 flex max-w-3xl gap-2 rounded-xl border border-gold/40 bg-white p-4 text-sm text-[#0B132B]" data-testid="rehab-independence-note">
          <Info className="h-4 w-4 shrink-0 text-gold" /> Rehab management is not offered on any property where Vertexhub performed a home inspection in the past 12 months.
        </div>
        <div className="mt-12 grid gap-6 lg:grid-cols-3">
          {TIERS.map(([n, p, items]) => (
            <div key={n} className="rounded-2xl border border-slate-200 bg-white p-7">
              <h2 className="font-display text-xl font-bold text-[#0B132B]">{n}</h2>
              <p className="mt-2 font-semibold text-gold">{p}</p>
              <ul className="mt-5 space-y-2">{items.map((i) => <li key={i} className="flex gap-2 text-sm text-slate-600"><Check className="h-4 w-4 shrink-0 text-gold" /> {i}</li>)}</ul>
            </div>
          ))}
        </div>
        <CtaButton to="/contact" size="lg" className="mt-10">Talk to us about your project</CtaButton>
      </div>
    </section>
  );
}
